<template>
  <div class="notice-container" :class="{ 'has-coupon': couponList.length }">
    <div class="notice-box">
      <div class="cell services">
        <div class="cell-l van-ellipsis">
          <span class="label">服务</span>
          <template v-for="item in services">
            <span class="services-item" :key="item.key">{{ item.name }}</span>
          </template>
        </div>
        <Icon name="arrow" color="black" size="10" />
      </div>
      <div class="cell ship">
        <span class="label">发货</span>
        <span class="value">
          最晚于
          {{
            dayjs()
              .add(deliverDay, 'day')
              .format('MM[月]DD[日]')
          }}
          {{
            deliverAddress
              ? CodeToText[JSON.parse(deliverAddress)[0]] +
                CodeToText[JSON.parse(deliverAddress)[1]] +
                CodeToText[JSON.parse(deliverAddress)[2]]
              : null
          }}
          发货
        </span>
      </div>
      <div class="cell coupon" v-if="couponList.length">
        <div class="cell-l van-ellipsis">
          <span class="label">优惠</span>
          <template v-for="item in couponList">
            <span class="coupon-item" :key="item.couponId"
              >{{
                item.threshold
                  ? '满' + item.threshold + '减' + item.faceValue
                  : '减' + item.faceValue
              }}
            </span>
          </template>
        </div>
        <div class="cell-r" @click="$emit('showGetCoupon')">
          <span class="btn">领券</span>
          <Icon name="arrow" color="red" size="10" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'
import { CodeToText } from 'element-china-area-data'
export default {
  components: { Icon },
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    deliverDay: {
      type: String,
      default: null,
    },
    deliverAddress: {
      type: String,
      default: null,
    },
    couponList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      CodeToText: CodeToText,
    }
  },
}
</script>

<style lang="less" scoped>
.notice-container {
  position: relative;
  top: -120px;
  height: 0;
  padding: 0 20px 20px;
  &.has-coupon {
    padding-bottom: 70px;
  }
}
.notice-box {
  background-color: #fff;
  box-shadow: 0 10px 10px 0 rgb(153 153 153 / 30%);
  border-radius: 12px;
  padding: 20px;
}
.cell {
  display: flex;
  font-size: 22px;
  & + .cell {
    margin-top: 12px;
  }
  .label {
    margin-right: 17px;
  }
  &.services {
    justify-content: space-between;
    align-items: center;
    .cell-l {
      flex: 1;
      min-width: 0;
      .services-item {
        color: #aeaeae;
        & + .services-item {
          margin-left: 8px;
        }
      }
    }
    .van-icon {
      font-weight: bold;
    }
  }
  &.ship {
    .value {
      flex: 1;
      min-width: 0;
      color: #aeaeae;
    }
  }
  &.coupon {
    justify-content: space-between;
    align-items: center;
    .cell-l {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      .coupon-item {
        border: 1px solid #f00;
        color: #f00;
        border-radius: 6px;
        padding: 0 6px;
        font-size: 20px;
        line-height: 1.2em;
        & + .coupon-item {
          margin-left: 8px;
        }
      }
    }
    .cell-r {
      color: #f00;
      .van-icon {
        position: relative;
        font-weight: bold;
        top: 2px;
        margin-left: 2px;
      }
    }
  }
}
</style>
